/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Open_Artifact_Not_ConfirmedInputs */



/**
* | output |
* | --- |
* | "Opening the other item was not confirmed." |
*
* @param {Canvas_Open_Artifact_Not_ConfirmedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_open_artifact_not_confirmed = /** @type {((inputs?: Canvas_Open_Artifact_Not_ConfirmedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Open_Artifact_Not_ConfirmedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Öffnen des anderen Elements wurde nicht bestätigt.")
	return /** @type {LocalizedString} */ ("Opening the other item was not confirmed.")
});